import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class PrintLabelService {

  constructor(private http: HttpClient) {}

  async getEventPrintLabel(query) {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      let response = await this.http
        .get(`${appApiResources.getEventPrintLabel}?event_id=${query.event_id}&role_id=${query.role_id}&language_id=${query.language_id}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }

  async postEventPrintLabel(data){
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      };
      let response = await this.http
      .post(`${appApiResources.postEventPrintLabel}`, data, httpOptions)
      .toPromise();
    return response;
      
    } catch (error) {
      return error;
    }
  }


}
